import { HttpStatusCode } from 'axios';
import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { logger } from '@trading-utils/logger';

import { appRoutes } from '../../config/appRoutes';

const handleAuthError = (error: any) => {
  if (error?.status === HttpStatusCode.Forbidden || error?.status === HttpStatusCode.Unauthorized) {
    logger.info('User redirected to Forbidden page.');
    window.location.replace(appRoutes.ERROR_403);
  }
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any) => {
      logger.error('Error on fetching data', {}, error);
      handleAuthError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error: any) => {
      logger.error('Error on mutation', {}, error);
      handleAuthError(error);
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error: any) => {
        if (error?.status === HttpStatusCode.Unauthorized || error?.status === HttpStatusCode.Forbidden) {
          return false;
        }
        return failureCount < 3;
      },
      staleTime: 5 * 60 * 1000,
    },
  },
});
